import useFlag from 'hooks/useFlag'
import React from 'react'
import AlertBannerMonolithic from './Monolithic'
import AlertBannerStyling from './Styling'

// Flag-gated during the Operations Center Phase 1 rollout:
//   - flag OFF → monolithic form (pre-split behaviour, all 8 fields on one page)
//   - flag ON  → styling-only form; settings move to /alert_banners under OC
// The flag stays on until Phase 2 ships, then this wrapper can be deleted and
// the styling-only scene becomes the default.
const AlertBanner = () => {
  const operationsCenterEnabled = useFlag('operations-center', false)
  return operationsCenterEnabled ? (
    <AlertBannerStyling />
  ) : (
    <AlertBannerMonolithic />
  )
}

export default AlertBanner
